<div *ngIf="isDrawerOpen" class="panel-backdrop" (click)="close()"></div>
<div class="notifications-panel" [class.is-open]="isDrawerOpen" (click)="$event.stopPropagation()">
    <div *ngIf="isLoading" class="panel-loading">
        <mat-spinner [diameter]="32"></mat-spinner>
    </div>
    <div *ngIf="hasAccessError && !isLoading" class="panel-error">
        <mat-icon color="warn">lock_outline</mat-icon>
        <span>You don't have access to notifications yet. Please contact your administrator to get access.</span>
    </div>
    <div *ngIf="hasError && !hasAccessError && !isLoading" class="panel-error">
        <mat-icon color="warn">error_outline</mat-icon>
        <span>Failed to load notifications</span>
        <button mat-button color="primary" (click)="retry()">Retry</button>
    </div>
    <iframe
        *ngIf="iframeUrl && !hasError"
        #notificationsIframe
        [src]="iframeUrl"
        [hidden]="isLoading"
        class="notifications-iframe"
        title="Notifications"
        frameborder="0"
    ></iframe>
</div>
